import VersionsIndex from '@/views/VersionsIndex.vue';
import VersionsCreate from '@/views/VersionsCreate.vue';

const routes = [
    {
        path: '/versions',
        name: 'VersionsIndex',
        component: VersionsIndex,
        meta: { layout: 'DashboardLayout' }
    },
    {
        path: '/versions/create',
        name: 'VersionsCreate',
        component: VersionsCreate,
        meta: { layout: 'DashboardLayout' }
    }
];

export default routes
